<template>
  <svg
    v-if="direction === 'right'"
    id="arrow_right"
    data-name="Arrow Right"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="`5 5 ${width} ${height}`"
  >
    <path
      id="arrow_right_path"
      data-name="Arrow Right Path"
      d="M1781.543,663.081l10.122,10.122-10.122,10.122"
      transform="translate(-1764.803 -651.215)"
      fill="none"
      :stroke="color"
      stroke-width="1"
    />
  </svg>
  <svg
    v-else
    id="arrow_left"
    data-name="Arrow Right"
    :width="width"
    :height="height"
    :viewBox="`5 5 ${width} ${height}`"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
  >
    <defs id="defs29" />
    <path
      id="arrow_left_path"
      data-name="Arrow Right Path"
      d="M 26.862,32.11 16.74,21.988 26.862,11.866"
      fill="none"
      :stroke="color"
      stroke-width="1"
    />
  </svg>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: '',
  components: {},
  props: {
    direction: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: '#F2F2F2',
    },
    width: {
      type: Number,
      default: 44,
    },
    height: {
      type: Number,
      default: 44,
    },
  },
  setup() {},
});
</script>

<style lang="scss" scoped></style>
